'use strict';

import * as tools from './../components/util/timeformat';

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function filterLapsTime() // Filter
{
	return function(data)
	{
		let ret;
		if (data.laps != null && data.laps >= 0)
			ret = `${data.laps}L ${tools.FormatFullTime(data.time)}`;
		else
			ret = " ";// "DNS";

		if (data.discarded === true)
			return `<span style="text-decoration:line-through">${ret}</span>`;
		else
			return ret;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function filterFullTime() // Filter
{
	return function(data)
	{
		return data != null ? tools.FormatFullTime(data) : null;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function filterLaptime() // Filter
{
	return function(data)
	{
		return data != null ? tools.FormatLapTime(data) : null;
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function filterDiff() // Filter
{
	return function(data) 
	{
		if (data.difflaps && data.difflaps !== 0)
		{
			if (data.difflaps > 0)
				return "+" + data.difflaps + "L";
			else
				return data.difflaps + "L";
		}
		else if (data.difftime && data.difftime !== 0)
		{
			if (data.difftime > 0)
				return "+" + tools.FormatLapTime(data.difftime);
			else
				return tools.FormatLapTime(data.difftime);
		}
		else
		{
			return null;
		}
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsPos = 
{
	template: 
	`<div ng-if="$ctrl.vm.pos >= 0" class="text-center">
		<span class="label labelpos" ng-class="{ posvalid: $ctrl.vm.valid }">{{$ctrl.vm.pos}}</span>
	</div>`,
	bindings: {
		vm: '<'
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsPosForced = 
{
	template: 
	`<div class="text-center">
		<span class="label labelpos" ng-class="{ posvalid: $ctrl.vm.valid }">{{$ctrl.pos}}</span>
	</div>`,
	bindings: {
		vm: '<',
		pos: '<'
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsLapsTime = 
{
	template: 
	`<div class="text-right" ng-class="{ispersonal: $ctrl.vm.valid}">
		<span ng-bind-html="$ctrl.vm | filterLapsTime"></span>
	</div>`,
	bindings: {
		vm: '<'
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsComparison = 
{
	template:
	`<everlaps-laps-time ng-if="$ctrl.vm.laps >= 0" vm="$ctrl.vm"></everlaps-laps-time>
	<everlaps-laptime ng-if="$ctrl.vm.laps == null" time="$ctrl.vm.time"></everlaps-laptime>`,
	bindings: {
		vm: '<'
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsTopX =
{
	template:
	`<div ng-if="$ctrl.value > 0">
		<span>{{$ctrl.value | filterLaptime}}</span>
	</div>
	<div ng-if="$ctrl.percent > 0">
		<span class="small">{{$ctrl.acronym | translate}}</span>&nbsp;<span class="small">{{$ctrl.percent}}%</span>
	</div>`,
	bindings: {
		value: '<',
		percent: '<',
		acronym: '<'
	}
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const everlapsLaptime =
{
	template: `<span class="right" ng-class="{ispersonal: $ctrl.ispersonal === true, isfastest: $ctrl.isfastest === true}">{{$ctrl.time|filterLaptime}}</span>`,
	bindings: {
		time: "<",
		isfastest: "<",
		ispersonal: "<"
	}/*,
	controller: function() 
	{
		this.$onInit = function() {
			this.formatted = this.time != null ? tools.FormatLapTime(this.time) : null;
		}
	}*/
}



// WEBPACK FOOTER //
// ./client/app/app.timefilters.js